import { faCertificate, faHandshake, faUsers} from "@fortawesome/free-solid-svg-icons";
import InfoCard from "../elements/InfoCard";
import { AdviseLabels } from "../enums/MessageEnum";

import sello40hrs from "../assets/img/sello40hrs.png"
import selloScrum from "../assets/img/selloScrum.png"
import mercadoPublico from "../assets/img/mercadopublico.png"
import mongoCertificate from "../assets/img/mongo-certificate.png"

import IconTooltip from "../elements/IconTooltip";
import Title from "../elements/Title";

export default function AboutUs(props){
    
    return(
        <div id='us' className="information-subsection bg-white">
            <Title title={AdviseLabels.US_TITLE}/>
            <div className="card-container">
                <div className="card-pad">
                    <InfoCard title={AdviseLabels.US_SUBTITLE}
                        body={
                            <>
                                <p className='text-gray-800' style={{fontSize: "1.15rem"}}>
                                    {AdviseLabels.US_MESSAGE}
                                </p>
                            </>
                        }
                        icon={faUsers}
                        sizeClass={'h-full'}
                        style={{width: "50vw", minWidth: "320px",
                                boxShadow: "1px 3px #888888"}}
                    />
                </div>
                <div className="card-pad">
                    <InfoCard title={AdviseLabels.PROMISE_TITLE}
                            body={
                                <>
                                    <p className='text-gray-800' style={{fontSize: "1.15rem"}}>
                                        {AdviseLabels.PROMISE_MESSAGE}
                                    </p>
                                </>
                                }
                            icon={faHandshake}
                            sizeClass={'h-full'}
                            style={{width: "38vw", minWidth: "320px",
                                    boxShadow: "1px 3px #888888"}}/>
                </div>
                <div className="card-pad">
                    <InfoCard title={AdviseLabels.CERTIFICATE_TITLE}
                            body={
                                <div className="card-container">
                                    <a href="/assets/pdf/RES_EXENTA_40_Horas.pdf"
                                       target="_blank" rel="noopener noreferrer">
                                        <IconTooltip width={'180px'} height={'180px'} src={sello40hrs}
                                                     name={AdviseLabels.CERTIFICATE_40HRS} id="cert40hrs"/>
                                    </a>
                                    <IconTooltip width={'180px'} height={'180px'} src={selloScrum}
                                                 name={AdviseLabels.CERTIFICATE_SCRUM} id="certScrum"/>
                                    <IconTooltip width={'263px'} height={'72px'} src={mercadoPublico}
                                                 name={AdviseLabels.MERCADO_PUBLICO} id="certMP"/>
                                    <IconTooltip width={'180px'} height={'180px'} src={mongoCertificate}
                                                 name={AdviseLabels.MONGO_CERTIFICATE} id="certMongo"/>
                                </div>
                            }
                        icon={faCertificate}
                        sizeClass={'h-full'}
                            style={{width: props.isLargeScreen ? "90vw" : "0", minWidth: "320px",
                            boxShadow: "1px 3px #888888"}}/>
                </div>
                
            </div> 
            <div className="card-container">
                
            </div>   
        </div>
    )
}